"use client";

import { createContext, useContext } from "react";

import type { SegmentedControlClassNames, SegmentedControlSlots } from "./segmentedControlVariants";

export interface SegmentedControlContext {
  slots: SegmentedControlSlots;
  classNames?: SegmentedControlClassNames;
}

const SegmentedControlContext = createContext<SegmentedControlContext | null>(null);

export function SegmentedControlProvider({
  children,
  value,
}: {
  children: React.ReactNode;
  value: SegmentedControlContext;
}) {
  return (
    <SegmentedControlContext.Provider value={value}>{children}</SegmentedControlContext.Provider>
  );
}

export function useSegmentedControlContext(): SegmentedControlContext {
  const context = useContext(SegmentedControlContext);
  if (!context) {
    throw new Error("SegmentedControl.Button must be used within a SegmentedControl");
  }
  return context;
}
